import { Nav, Tab } from "react-bootstrap";
import DepositTable from "./Funds Page/DepositTable";
import WithdrawTable from "./Funds Page/WithdrawTable";
import { useEffect, useState } from "react";

function FundsHistory() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 574);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 574);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Tab.Container defaultActiveKey="Buy">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div
                className={`card-header border-0 ${
                  isMobile ? "d-flex flex-column" : ""
                }`}>
                <h4 className="heading">Deposit & Withdrawal Statement</h4>
                <nav>
                  <Nav
                    className="order nav nav-tabs"
                    id="nav-tab-p2p"
                    role="tablist">
                    <Nav.Link
                      as="button"
                      eventKey="Buy"
                      type="button"
                      className={
                        isMobile ? "border rounded px-3 py-2 mb-2" : ""
                      }>
                      Deposit
                    </Nav.Link>
                    <Nav.Link
                      as="button"
                      eventKey="Sell"
                      type="button"
                      className={
                        isMobile ? "border rounded px-3 py-2 mb-2" : ""
                      }>
                      Withdrawal
                    </Nav.Link>
                  </Nav>
                </nav>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <Tab.Content>
                  <Tab.Pane eventKey="Buy">
                    <h4 className="heading">Deposit</h4>
                    <DepositTable />
                  </Tab.Pane>
                  <Tab.Pane eventKey="Sell">
                    <h4 className="heading">Withdrawal</h4>
                    <WithdrawTable />
                    {/* <SellBthTable /> */}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
}

export default FundsHistory;
